import { Dispatch, SetStateAction } from 'react';

import { Visible } from 'coreOld/components';
import PreviewModal from 'partsOld/components/PreviewModal';
import { ModalStep } from 'partsOld/enums';
import { IPill } from 'partsOld/types';

import ImportTableModal from './ImportTableModal';

interface IProps {
  records: Array<Array<string>>;
  initialPills: IPill[];
  pills: IPill[];
  clearHeaders: () => void;
  onCheckboxChange: (isPricing: boolean) => void;
  setAddNewHeader: Dispatch<SetStateAction<boolean>>;
  addNewHeader: boolean;
  isUploadSuccessful: boolean;
  isLoading: boolean;
  quantityCheckbox: boolean;
  pricingCheckbox: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage;
  onConfirmMapping: () => Promise<void>;
  step: ModalStep;
  setStep: Dispatch<SetStateAction<ModalStep>>;
  data;
}

const ImportModalView = ({
  records,
  isUploadSuccessful,
  initialPills,
  clearHeaders,
  isLoading,
  onCheckboxChange,
  pills,
  quantityCheckbox,
  pricingCheckbox,
  setAddNewHeader,
  addNewHeader,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  onConfirmMapping,
  step,
  setStep,
  data,
}: IProps) => {
  return (
    <>
      <Visible when={step === ModalStep.COLUMNS_HEADERS}>
        <ImportTableModal
          {...{
            isUploadSuccessful,
            initialPills,
            pills,
            records,
            clearHeaders,
            onCheckboxChange,
            pricingCheckbox,
            quantityCheckbox,
            isLoading,
            setAddNewHeader,
            addNewHeader,
            fetchNextPage,
            hasNextPage,
            isFetchingNextPage,
            onConfirmMapping,
          }}
        />
      </Visible>

      <Visible when={step === ModalStep.PREVIEW_ROWS}>
        <PreviewModal partImport={data.partImport} data={data} setStep={setStep} />
      </Visible>
    </>
  );
};

export default ImportModalView;
